var parent = require('../../stable/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/get-own-property-symbols.js
// module id = 3495
// module chunks = 25